import { authorizedApi } from './index';

export const transactionAttemptsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    placeTransactionAttempt: builder.mutation({
      query: ({ transactionAttemptId }) => ({
        url: `/transaction-attempts/${transactionAttemptId}/place`,
        method: 'POST',
      }),
    }),
  }),
});

export const { usePlaceTransactionAttemptMutation } = transactionAttemptsApi;
